import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import Diagnostics from '@/modules/profile/Diagnostics'
import { useAppSelector } from '@/redux/store'
import { Stack } from 'expo-router'

export default function DiagnosticsPage() {
  const currentUser = useAppSelector(state => state.currentUser.user)
  const headerLeftItems = useWebBackButton('/profile')

  return (
    <>
      <Stack.Screen options={{ ...buildScreenHeaderItems({ left: headerLeftItems }) }} />
      <Diagnostics userId={currentUser?.id} teamId={currentUser?.billingAccount.id} />
    </>
  )
}
